import './navigation-bar.css';
import { Tab } from '../../../types';
import { MidiStatus } from '../../../midi';

interface NavigationBarProps {
  activeTab: Tab;
  onTabChange: (tab: Tab) => void;
  midiStatus: MidiStatus;
}

const MIDI_LABELS: Record<MidiStatus, string> = {
  pending:      'Requesting MIDI access…',
  connected:    'MIDI device connected',
  'no-devices': 'MIDI ready — no devices detected',
  unsupported:  'Web MIDI not supported in this browser',
  denied:       'MIDI access denied',
};

export const NavigationBar = ({ activeTab, onTabChange, midiStatus }: NavigationBarProps) => {
  return <nav className="sk-nav-bar" role="tablist" aria-label="SynthKitty sections">
    <button
      role="tab"
      aria-selected={activeTab === 'oscillators'}
      aria-controls="tabpanel-oscillators"
      id="tab-oscillators"
      className={activeTab === 'oscillators' ? 'active' : ''}
      onClick={() => onTabChange('oscillators')}
    >Oscillators</button>
    <button
      role="tab"
      aria-selected={activeTab === 'composer'}
      aria-controls="tabpanel-composer"
      id="tab-composer"
      className={activeTab === 'composer' ? 'active' : ''}
      onClick={() => onTabChange('composer')}
    >Composer</button>
    <button
      role="tab"
      aria-selected={activeTab === 'projects'}
      aria-controls="tabpanel-projects"
      id="tab-projects"
      className={activeTab === 'projects' ? 'active' : ''}
      onClick={() => onTabChange('projects')}
    >Projects</button>
    <button
      role="tab"
      aria-selected={activeTab === 'credits'}
      aria-controls="tabpanel-credits"
      id="tab-credits"
      className={activeTab === 'credits' ? 'active' : ''}
      onClick={() => onTabChange('credits')}
    >Credits</button>

    <div className="sk-midi-indicator" title={MIDI_LABELS[midiStatus]}>
      <span className={`sk-midi-dot sk-midi-dot--${midiStatus}`} aria-hidden="true" />
      <span className="pixel-font sk-midi-label">MIDI</span>
    </div>
  </nav>
}
